import { render, staticRenderFns } from "./ChatUsers.vue?vue&type=template&id=6f022dda&scoped=true&"
import script from "./ChatUsers.vue?vue&type=script&lang=js&"
export * from "./ChatUsers.vue?vue&type=script&lang=js&"
import style0 from "./ChatUsers.vue?vue&type=style&index=0&id=6f022dda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f022dda",
  null
  
)

export default component.exports